import { getFullUrl } from 'hubspot-url-utils';
import AbstractBanner from '../AbstractBanner/AbstractBanner';
import { getSandboxPortalParent, getIsSandboxPortal, getRedirect } from './SandboxBannerUtils';
import { memo, useEffect, useState } from 'react';
import TrackedLink from '../../TrackedLink';
import I18n from 'I18n';
import Raven from 'raven-js';
import { getPortalId } from '../../../utils/getPortalId';
import { sanitizeHtml } from 'notifications-display';
import { jsx as _jsx } from "react/jsx-runtime";
const SANDBOX = 11;
const DEVELOPMENT_SANDBOX = 'DEVELOPER';
const SandboxBanner = () => {
  const [sandboxName, setSandboxName] = useState('');
  const [isSandboxPortal, setIsSandboxPortal] = useState(false);
  const [isDevelopmentSandbox, setIsDevelopmentSandbox] = useState(false);
  const [parentPortalId, setParentPortalId] = useState(null);
  const portalId = getPortalId();
  useEffect(() => {
    getIsSandboxPortal(portalId).then(sandboxResponse => {
      if (sandboxResponse && sandboxResponse.hubType === SANDBOX) {
        setSandboxName(sandboxResponse.accountName || '');
        setIsSandboxPortal(true);
        return getSandboxPortalParent(portalId);
      }
      return null;
    }).then(parentResponse => {
      if (parentResponse) {
        setIsDevelopmentSandbox(parentResponse.type === DEVELOPMENT_SANDBOX);
        setParentPortalId(parentResponse.parentHubId);
      }
    }).catch(err => {
      Raven.captureException(err);
    });
  }, [portalId]);

  /*
  if a sandboxName contains an escape character it will render the escape character as a string
  This will decode the escape character to render the correct character
  */
  const decodeHTMLEntities = text => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    return textarea.value;
  };
  const bannerText = isDevelopmentSandbox ? I18n.text('alerts.sandbox.developmentSandbox', {
    sandboxName,
    defaultValue: `You're in ${sandboxName}, which is a development sandbox account.`
  }) : I18n.text('alerts.sandbox.sandboxAccount', {
    sandboxName,
    defaultValue: `You're in ${sandboxName}, which is a standard sandbox account.`
  });
  const decodedBannerText = sanitizeHtml(decodeHTMLEntities(bannerText), []);
  const sandboxLinkText = I18n.text('alerts.sandbox.linkText', {
    defaultValue: 'Go back to my production account.'
  });
  const errorText = I18n.text('alerts.sandbox.somethingWentWrong', {
    defaultValue: 'Something went wrong finding the url for your production account. Please reload the page to try again.'
  });
  const bannerMessage = parentPortalId ? /*#__PURE__*/_jsx(TrackedLink, {
    href: `${getFullUrl('app')}/${getRedirect()}/${parentPortalId}`,
    children: sandboxLinkText
  }) : errorText;
  return isSandboxPortal ? /*#__PURE__*/_jsx(AbstractBanner, {
    isCloseable: false,
    "data-test-id": 'sandbox-banner',
    type: 'warning',
    title: decodedBannerText,
    children: /*#__PURE__*/_jsx("span", {
      children: bannerMessage
    })
  }) : null;
};
export default /*#__PURE__*/memo(SandboxBanner);